// extracted by mini-css-extract-plugin
export var image = "styles-module--image--QqVEn";
export var section = "styles-module--section--JMvqx";
export var line = "styles-module--line--b7SVb";
export var button = "styles-module--button--LWqL4";